<template>
  <div class="bao">
    <el-card class="box-card contaier">
      <div class="container">
        <div class="title">
          {{$t('sidebar.message')}}
        </div>
        <div class="main">
          <div class="content">
            <el-table
              :data="tableData"
              :header-cell-style="{
                background: '#FDC400',
                color: '#333',
                height: '42px',
              }"
            >
              <el-table-column
                prop="companyNameC"
                :label="$t('messages.company')"
                width="120"
              >
                <template slot-scope="scope">
                  <div class="company">
                    <span>{{
                      scope.row.companyNameC || scope.row.companyNameE
                    }}</span>

                    <span v-if="scope.row.count" class="count">{{
                      scope.row.count
                    }}</span>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                prop="time"
                width="120"
                :label="$t('messages.time')"
              >
              </el-table-column>

              <el-table-column :label="$t('common.option')">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    class="view"
                    @click="view(scope.row)"
                    >{{ $t("common.view") }}</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import { getLists } from "../../../api/message.js";
export default {
  data() {
    return {
      activeName: "first",
      tableData: [],
      num: "",
    };
  },
  created() {
    this.getLists();
  },
  methods: {
    view(row) {
      this.$router.push({
        name: "messageDetail",
        query: {
          sendUserId: row.sendUserId,
          receiveUserId: row.receiveUserId,
        },
      });
    },

    async getLists() {
      try {
        const { data } = await getLists();
        if (data.code === 200) {
          this.tableData = data.data;
          let count = this.unread(this.tableData);
          if (count > 0) {
            this.$emit("getMessage", true);
          } else {
            this.$emit("getMessage", false);
          }
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    unread(arr) {
      let count = 0;
      arr.forEach((item, index) => {
        if (item.count != 0) {
          count += 1;
        }
      });

      console.log("未读的消息数量是:", count);
      return count; //计算未读的消息数
    },
  },

  beforeRouteLeave(to, from, next) {
    if (to.name == "messageDetail") {
      let count = this.unread(this.tableData);
      if (count - 1 < 1) {
        this.$emit("getMessage", false);
        next();
      } else {
        this.$emit("getMessage", true);
        next();
      }
    } else {
      next();
    }
  },
};
</script>
<style lang="scss" scoped>
.bao {
  padding-top: 50px;
  background-color: skyblue;
}
.container {
  .title {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 65px;
    height: 65px;
    background: #ffffff;

    padding-left: 15px;
    box-sizing: border-box;
    margin-bottom: 10px;
  }
}

.count {
  position: absolute;
  top: 3px;
  right: -5px;
  width: 15px;
  height: 15px;
  text-align: center;
  line-height: 15px;
  background: #ff190c;
  border-radius: 50%;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  display: block;
}
.company {
  position: relative;
}

.content {
  padding: 10px 10px 10px 10px;

  background-color: white;
}
</style>
<style scoped>
.el-table td,
.el-table >>> th {
  padding: 10px 0;
}

.bao >>> .el-card__body {
  background: #f0f2f5;
  padding: 0px !important;
  padding: 10px !important;
}
.view{
  text-align: center;

  width: 100%;
}
</style>
